export default "/assets/aca12a7d7a5700c13d0491a28a8ca070.jpg";